import { render, staticRenderFns } from "./ModalNewServiceSetup.vue?vue&type=template&id=bdd52f1c&scoped=true&"
import script from "./ModalNewServiceSetup.vue?vue&type=script&lang=js&"
export * from "./ModalNewServiceSetup.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewServiceSetup.vue?vue&type=style&index=0&id=bdd52f1c&scoped=true&lang=css&"
import style1 from "./ModalNewServiceSetup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd52f1c",
  null
  
)

export default component.exports